import $ from 'jquery';
import Slider, {
  cssClassLazyloadOnSlide,
  cssClassSwiperWrapper,
} from '../../js/modules/Slider.mjs';
import {
  gridBreakpoints,
  gridGutterWidth,
} from '../../js/utilities/media-queries.mjs';

const $sliders = $('.js_ef-collection-teaser-flag');

$sliders.each((index, slider) => {
  const $slider = $(slider);
  const $sliderWrapper = $slider.find(`.${cssClassSwiperWrapper}`);
  const SliderCollectionTeaserFlag = new Slider({
    namespace: 'CollectionTeaserFlag',
    sliderNode: slider,
    swiperConfigOverride: {
      breakpoints: {
        [gridBreakpoints.xs]: {
          slidesPerView: 1,
          spaceBetween: gridGutterWidth
        },
        [gridBreakpoints.lg]: {
          slidesPerView: 2,
          spaceBetween: gridGutterWidth
        },
      }
    },
    callbacks: {
      onInitStart() {
        $sliderWrapper.addClass('no-gutters');
      },
      onDestroy() {
        $sliderWrapper.removeClass('no-gutters');
      },
    },
  });

  if (SliderCollectionTeaserFlag.slidesDontFitIntoWrapper()) {
    SliderCollectionTeaserFlag.init();
  } else {
    $slider.find(`.${cssClassLazyloadOnSlide}`).addClass('lazyload');
  }
  SliderCollectionTeaserFlag.attachResize();
});
